import { render, staticRenderFns } from "./invitacion.vue?vue&type=template&id=6ea2abd4"
import script from "./invitacion.vue?vue&type=script&lang=js"
export * from "./invitacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports